// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1JIsy","alertIcon":"ConfirmModal_alertIcon__c9mca"};